<ng-container *ngIf="tilesLoaded$ | async">
  <fm-map-overlay-container [@replayMapOverlayHide]="replayAnimationState"> </fm-map-overlay-container>

  <div
    *ngIf="showReplaySidePanel && isReplayModuleLoaded$ | async"
    [@replayPanel]
    (@replayPanel.done)="onReplayAnimationDone($event)"
    (@replayPanel.start)="onReplayAnimationStart($event)"
  >
    <ng-container fmLoadModule="replay" [fmLoadModuleDestroyModuleWithComponent]="false"></ng-container>
  </div>

  <fm-notifications
    class="notification-alert"
    [ngClass]="{ 'cookie-visible': !isCookieAccepted }"
    [notificationsEnabled]="(userPermissions$ | async)?.alerts"
    [notificationPreferences]="notificationPreferences$ | async"
    [showPanicAlertsOnly]="isReplayOpen$ | async"
    [deviceStatusEnabled]="(userFeatures$ | async)?.deviceStatusChange"
    (showOnMapClicked)="showDeviceStatusOnMap($event)"
  ></fm-notifications>

  <fm-overlay-map-menus
    [menuType]="mapContextMenuType"
    [menuData]="mapContextMenuData"
    (menuClosed)="onMapContextMenuClosed()"
  ></fm-overlay-map-menus>

  <fm-overlay-balloon [balloon]="balloon$ | async" [balloonTemplate]="balloonTemplate"></fm-overlay-balloon>
</ng-container>

<fm-map-container>
  <fm-google-maps
    fmGoogleMapsGeofenceDrawing
    #map
    [balloon]="balloon$ | async"
    [balloonTemplate]="balloonTemplate"
    [isStreetViewVisible]="isStreetViewOpen$ | async"
    [isTrafficEnabled]="isTrafficEnabled$ | async"
    [mapType]="mapType$ | async"
    [markerLabel]="markerLabel$ | async"
    [markers]="markers$ | async"
    [polylines]="replayPolylines$ | async"
    [markersLabels]="markersLabels$ | async"
    [markerToHighlight]="markerToHighlight$ | async"
    [selectedMarker]="selectedMarker$ | async"
    [maxPlottableMarkers]="maxPlottableMarkers$ | async"
    [overlayControlMargins]="overlayMargins$ | async"
    [plotTypeConfigs]="plotTypeConfigs"
    [plotTypeDependencies]="plotTypeDependencies"
    [plotClusterConfig]="plotClusterConfig$ | async"
    [plotTypesToShowLabel]="plotTypesToShowLabel"
    [shouldFitToMap]="isMapFitted$ | async"
    [triggerFitToMap]="triggerFitToMap$ | async"
    [streetViewToLocation]="streetViewLocation$ | async"
    [zoomToLocation]="zoomToLocation$ | async"
    [zoomToMarker]="zoomToMarker$ | async"
    [startLocation]="mapStartingLocation$ | async"
    [changeBounds]="mapBounds$ | async"
    [clusterBalloonZoomToClicked]="clusterBalloonZoomToClicked$ | async"
    [geofenceDrawingShape]="geofenceDrawingShape$ | async"
    [geofenceShapeLatLng]="geofenceDrawingShapeLatLng$ | async"
    [isGeofenceCreateOpen]="isGeofenceCreateOpen$ | async"
    [clearShape]="geofenceDrawingControlClearPressed$ | async"
    [geofenceShape]="geofenceShape$ | async"
    (balloonClosed)="onBalloonClosed()"
    (boundsChanged)="onBoundsChanges($event)"
    (currentPlotChanged)="onCurrentPlotChanges($event)"
    (currentPlotStartHover)="onCurrentPlotStartHover($event)"
    (currentPlotEndHover)="onCurrentPlotEndHover()"
    (fitToMapUpdated)="onFitToMapChanges($event)"
    (mapCenterChanged)="onMapCenterChange($event)"
    (markerClicked)="onMarkerClick($event)"
    (markerRightClicked)="showMarkerContextMenu($event)"
    (plotsInBoundsChanged)="onPlotsInBoundsChanges($event)"
    (removeZoomToMarker)="onRemoveZoomToMarker()"
    (rightClicked)="showMapContextMenu($event)"
    (streetViewChanged)="onStreetViewChange($event)"
    (polylineStartHover)="onPolylineStartHover($event)"
    (polylineEndHover)="onPolylineEndHover()"
    (polylineClicked)="onPolylineClicked($event)"
    (zoomLevelChanged)="onZoomLevelChanged($event)"
    (mapTilesLoadedFirstTime)="onMapTilesLoadedFirstTime()"
    (clusterClicked)="clusterClicked($event)"
    (mapLoaded)="mapLoaded()"
    (geofenceShapeChanged)="geofenceShapeChanged($event)"
  ></fm-google-maps>
</fm-map-container>

<ng-template #balloonTemplate let-balloon>
  <fm-vehicle-work-order-balloon
    *ngIf="
      balloon?.marker.type === EPlotType.vehicle ||
      balloon?.marker.type === EPlotType.poweredAsset ||
      balloon?.marker.type === EPlotType.workOrder
    "
    [balloon]="balloon$ | async"
    [isStreetViewAvailable]="isStreetViewAvailableForMarker"
    [permissions]="userPermissions$ | async"
    [userCountry]="(userSettings$ | async)?.Country"
    [vehiclePlotsTimer]="getBalloonTimer(balloon?.id) | async"
    [speedLimitOption]="(userAccountSettings$ | async)?.SpeedLimitOption"
    [showTachoInformation]="showTachoInformation$ | async"
    [showVehicleBalloonLinks]="showVehicleBalloonLinks$ | async"
    [customBalloonFeatureEnabled]="customBalloonFeatureEnabled$ | async"
    [showVehicleBalloonEcm]="showVehicleBalloonEcm$ | async"
    [vehicleFuelType]="(vehicleFuelTypes$ | async).get(balloon.id)"
    [disableZoomTo]="disableZoomTo"
    [userSettings]="userSettings$ | async"
    [vehicleLastStateChangeDuration]="vehicleLastStateChangeDuration$ | async"
    [vehicleHealthStatus]="vehicleDeviceHealthStatus$ | async"
    (replay)="onVehicleReplay($event.id)"
    (streetViewClicked)="onBalloonStreetViewClicked($event)"
    (showMessage)="onVehicleWorkOrderBalloonShowMessage($event)"
    (zoomTo)="onBalloonZoomTo($event)"
    (scheduledJobClicked)="onScheduledJobClicked($event)"
    (resized)="vehicleWorkOrderBalloonResized($event)"
  ></fm-vehicle-work-order-balloon>

  <fm-place-balloon
    *ngIf="balloon?.marker.type === EPlotType.geofence || balloon?.marker.type === EPlotType.hotspot"
    [balloon]="balloon"
    [permissions]="userPermissions$ | async"
    (editClicked)="onPlaceBalloonEditClicked($event)"
    (findNearestClicked)="onBalloonFindNearestClicked($event)"
    (viewMetricsClicked)="onPlaceBalloonViewMetricsClicked($event)"
  ></fm-place-balloon>

  <fm-garmin-balloon
    *ngIf="balloon?.marker.type === EPlotType.garmin"
    [balloon]="balloon"
    [isStreetViewAvailable]="isStreetViewAvailableForMarker"
    (streetViewClicked)="onBalloonStreetViewClicked($event)"
    (zoomTo)="onBalloonZoomTo($event)"
  ></fm-garmin-balloon>

  <fm-harsh-driving-event-balloon
    *ngIf="balloon?.marker.type === EPlotType.harshDrivingEvent"
    [balloon]="balloon"
    [permissions]="userPermissions$ | async"
    [userSettings]="userSettings$ | async"
    (backToVideoClicked)="onBalloonBackToVideo($event)"
    (directionsClicked)="onBalloonGetDirectionsTo($event)"
    (findNearestClicked)="onBalloonFindNearestClicked($event)"
    (replayClicked)="onHarshDrivingEventReplay($event)"
  ></fm-harsh-driving-event-balloon>

  <fm-asset-balloon
    *ngIf="balloon?.marker.type === EPlotType.asset"
    [balloon]="balloon"
    [isStreetViewAvailable]="isStreetViewAvailableForMarker"
    [permissions]="userPermissions$ | async"
    [disableZoomTo]="disableZoomTo"
    [vehicleHealthStatus]="vehicleDeviceHealthStatus$ | async"
    (streetViewClicked)="onBalloonStreetViewClicked($event)"
    (zoomToClicked)="onAssetBalloonZoomTo($event)"
    (locationHistoryClicked)="onBalloonLocationHistory($event)"
    (replayClicked)="onAssetReplay($event)"
  ></fm-asset-balloon>

  <fm-replay-balloon
    *ngIf="balloon?.marker.type === EPlotType.replay"
    [balloon]="balloon"
    [userSettings]="userSettings$ | async"
    [permissions]="userPermissions$ | async"
    [videoDeviceInfo]="videoDeviceInfo$ | async"
    [isStreetViewAvailable]="isStreetViewAvailableForMarker"
    (streetViewClicked)="onBalloonStreetViewClicked($event)"
    (requestVideoClicked)="onBalloonRequestVideoInJourney($event)"
    (previousPlotClicked)="onBalloonPreviousPlotInJourney($event)"
    (nextPlotClicked)="onBalloonNextPlotInJourney($event)"
  ></fm-replay-balloon>

  <fm-polyline-hover-balloon
    *ngIf="balloon?.marker.type === EPlotType.polyline"
    [balloon]="balloon"
    [userSettings]="userSettings$ | async"
  ></fm-polyline-hover-balloon>

  <fm-cluster-balloon
    *ngIf="balloon?.marker.type === EPlotType.cluster"
    [balloon]="balloon"
    [userSettings]="userSettings$ | async"
    (zoomTo)="onClusterBalloonZoomTo($event)"
    (itemClicked)="onClusterBalloonItemClicked($event)"
    (itemRightClicked)="onClusterBalloonItemRightClicked($event)"
  ></fm-cluster-balloon>
</ng-template>

<ng-template #maxPlottableWarningTemplate i18n="@@S_TOO_MUCH_DETAIL">
  There is too much detail to show on the map at this level. Try zooming in.
</ng-template>

<ng-template #snackbarSuccessTemplate>
  <span i18n="@@S_DEVICESTATUS_STATUS_ACKNOWLEDGED" *ngIf="snackbarConfirmedAs === deviceStatusSnackbarTypes.correct"
    >Vehicle status acknowledged</span
  >
  <span i18n="@@S_DEVICESTATUS_CONTACT_SENT" *ngIf="snackbarConfirmedAs === deviceStatusSnackbarTypes.incorrect">Contact details sent</span>
  <span i18n="@@S_DEVICESTATUS_STATUS_DISMISSED" *ngIf="snackbarConfirmedAs === deviceStatusSnackbarTypes.seen"
    >Vehicle status dismissed</span
  >
</ng-template>

<ng-template #snackbarErrorTemplate i18n="@@S_DEVICESTATUS_ACTION_ERROR">
  There was an error processing your request, please try again.
</ng-template>
